import(/* webpackMode: "eager", webpackExports: ["PortalContextProvider"] */ "/vercel/path0/apps/portals/src/wrappers/PortalContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/vercel/path0/packages/@wolfejs/ui/ErrorBoundary/ErrorBoundary.tsx");
